var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { showList: _vm.active }, attrs: { id: _vm.listId } },
    [
      _vm._l(_vm.items, function (item, index) {
        return _c(
          "li",
          {
            key: index,
            style:
              index < _vm.limitItems
                ? { display: "list-item" }
                : { display: "none" },
            attrs: { id: index },
          },
          [_vm._v("\n " + _vm._s(item[_vm.nameField]) + "\n    ")]
        )
      }),
      _vm._v(" "),
      _vm.items.length > _vm.limitItems
        ? _c(
            "a",
            {
              staticClass: "text-primary text-capitalize",
              on: { click: _vm.toggle },
            },
            [
              _vm.active
                ? _c("span", [
                    _vm._v(_vm._s(_vm.Lang.get("messages.show_less"))),
                  ])
                : _c("span", [
                    _vm._v(_vm._s(_vm.Lang.get("messages.show_all"))),
                  ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }